import { Theme, css } from '@emotion/react';

export const heroCardRoot = css`
  display: flex;
  flex-direction: column;
`;

export const heroCardText = (theme: Theme, color?: string) => css`
  background-color: ${theme.colors.bgDefault};
  border-top: ${color ? theme.spacing(1) : 0}px solid ${color};
  color: ${theme.colors.fgDefault};
  order: 1;
  padding: ${theme.spacing(3.5)}px;
  text-align: center;

  ${theme.breakpoints.up('md')} {
    align-items: center;
    background: ${color || theme.colors.bgDarker};
    border-top: none;
    color: ${theme.colors.fgContrast};
    display: flex;
    justify-content: space-between;
    order: initial;
    padding: ${theme.spacing(3.5)}px;
  }
`;

export const imageHeightMobile = 176;

export const imageHeightDesktop = 306;

export const heroCardImage = (theme: Theme) => css`
  display: block;
  height: ${imageHeightMobile}px;
  object-fit: cover;
  object-position: center;
  width: 100%;

  ${theme.breakpoints.up('md')} {
    height: ${imageHeightDesktop}px;
  }
`;
